module.exports = __webpack_public_path__ + "img/snack.fa583ff.svg";